import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as AdminIndexActions from '../../../actions/admin/Index/adminIndexAction';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import autoBind from 'auto-bind';

let btnSize = { fontSize: '13' };
class EmailTemplateList extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			isLoader: true,
			emailTemplateList: [],
			token: '',
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			totalCount: 0
		}
		this.deleteemailTemplate = this.deleteemailTemplate.bind(this);
	}

	deleteemailTemplate(item) {
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to delete this template ?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						let object = {
							page: this.state.activePage,
							count: this.state.count,
						}
						let Id = item._id
						this.props.actions.deleteemailTemplate(object, Id);
					}
				},
				{
					label: 'No',
					onClick: () => { this.props.history.push('/user/email-templates'); }
				}
			]
		})

	}

	goToAddblogPage() {
		this.props.history.push('/user/add-email-template');
	};
	goToEditblogPage(index) {
		this.props.history.push('/user/edit-email-template/' + this.state.emailTemplateList[index]._id);
	}
	componentWillMount() {
		let object = {
			page: this.state.activePage,
			count: this.state.count,
		}
		this.props.actions.getEmailTemplateList(object);
	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let object = {
			page: pageNumber,
			count: this.state.count,
		}
		this.props.actions.getEmailTemplateList(object);
	}

	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}

	//function for sorting
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();
		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let object = {
			page: this.state.page,
			count: this.state.count,
			sorting: sorting
		}
		this.props.actions.getEmailTemplateList(object);
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.success) {
			this.setState({
				emailTemplateList: nextProps.emailTemplateList,
				totalCount: nextProps.totalCount,
				// isLoader: false
			})
		} else {
			this.setState({
				isLoader: false
			})
		}
	}

	render() {
		var emailTemplateList = this.state.emailTemplateList
		var rows = [];
		emailTemplateList.forEach(function (item, index) {
			rows.push(
				<tr key={index}>
					<td>{index + 1}</td>
					<td>
						{item.subject}
					</td>
					{/* <td>
						{item.description}
					</td> */}
					<td> <Moment format="DD-MMM-YYYY">{item.createdAt}</Moment>     </td>
					<td>
						<Link to={'/user/emailTemplateView/' + item._id} style={{ cursor: 'pointer', marginRight: 10 }} className="redLink"><img src={require('../../../images/img/book.png')} style={{ 'cursor': 'pointer' }} /></Link>
						<Link to={'/user/edit-email-template/' + item._id} style={{ cursor: 'pointer', marginRight: 10 }} className="redLink"><img src={require('../../../images/edit.png')} alt="" width="14px" /></Link>
						{/* <Link onClick={this.deleteemailTemplate.bind(this, item)} style={{ "cursor": "pointer" }} className="redLink"><i className="fa fa-trash"></i></Link> */}
					</td>

				</tr >
			)
		}.bind(this));
		return (
			<div className="content-wrapper" >

				<section className="content container-fluid">
					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link to="#tab_1" data-toggle="tab" className="active show">Email Templates</Link></li>

									</ul>
									<div className="uploadImg-btn">
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="tab-content tabother ">
												<div className="row">
													<div className="box-body table-responsive no-padding aTable">
													<div className="table-responsive">
														<table className="table">
															<tbody>
																<tr>
																	<th >
																		Sr. No.
                                </th>
																	<th>
																		Template Subject</th>
																	{/* <th >
																		Template Content
                                </th> */}
																	<th>Creation date</th>
																	<th >Action</th>
																</tr>
																{rows && rows.length > 0 ? rows : <tr><td colSpan={4} className="text-center">There are no Email Templates</td></tr>}
															</tbody>
														</table>
													</div></div>
												</div>
												{(this.state.totalCount && this.state.totalCount > 10) ?
													<div className="row">
														<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
														<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
															<Pagination
																prevPageText='Prev'
																nextPageText='Next'
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCount}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange.bind(this)}
															/>
														</div>
													</div> : ''}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		emailTemplateList: state.adminUser.emailTemplates ? state.adminUser.emailTemplates.data : [],
		totalCount: state.adminUser.emailTemplates ? state.adminUser.emailTemplates.totalCount : 0,
		success: state.adminUser.emailTemplates ? state.adminUser.emailTemplates.success : false
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(AdminIndexActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplateList);